import Select from 'components/Inputs/Select';
import { useLocale, useTranslations } from 'next-intl';
import { sortByLocale } from 'utils/sortingMethods';

export default function ConfigureSorting({
  sorting,
  setSorting,
  sortableKeys,
  sortableKeysLabels
}) {
  const t = useTranslations();
  const locale = useLocale();

  const handleSelectAtribute = ({ value }) =>
    setSorting({ ...sorting, sortAttribute: value, page: 1 });
  const handleSelectOrder = ({ value }) =>
    setSorting({ ...sorting, sortOrder: e.target.value, page: 1 });

  if (!sortableKeys) return null;

  const sortingOptions = sortableKeys
    .map((value) => ({ label: sortableKeysLabels(value), value: value }))
    .sort(({ label: a }, { label: b }) => sortByLocale(locale)(a, b));

  return (
    <>
      <h2 className="subtitle1">{t('transactions.sort_by')}</h2>
      <div className="mb-3 grid">
        <div className="gcol-6">
          <Select
            selectedValue={sorting.sortAttribute}
            options={sortingOptions}
            onChange={handleSelectAtribute}
          />
        </div>
        <div className="gcol-6">
          <Select
            selectedValue={sorting.sortOrder}
            options={['asc', 'desc'].map((value) => ({ value, label: t(`transactions.${value}`) }))}
            onChange={handleSelectOrder}
          />
        </div>
      </div>
    </>
  );
}
